import React, { useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import Button from 'react-bootstrap/Button';

/* Symbols */
import chevronDownIcon from 'symbols/chevron-down.svg';

/* Common */
import { Icon } from 'js/components/atoms';

export default function FilterCollapse(props) {
    const {
        children,
        eventKey,
        transKey,
        title
    } = props;

    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;

    /* Render */
    return (
        <div className={`collapse-item ${isCurrentEventKey ? 'collapse-show' : ''}`}>
            <Accordion.Toggle
                as={Button}
                variant="none"
                className="btn--collapse justify-content-between btn-block"
                title={title}
                aria-expanded={isCurrentEventKey}
                eventKey={eventKey}
            >
                <span className={`btn__text${transKey === 'price_incl_conversion' ? ' btn__text-unset' : ' text-capitalize'} text--16 font-weight-semi-bold`}>
                    {title}
                </span>
                <div className="btn__icon">
                    <Icon url={chevronDownIcon.url} size={24} />
                </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={eventKey}>
                {children}
            </Accordion.Collapse>
        </div>
    );
}
